var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stars mr-2"},[_vm._l((_vm.fullStars),function(star,idx){return _c('i',{key:star + idx,staticClass:"fas fa-star"})}),_vm._l((_vm.emptyStars),function(star,idx){return _c('i',{key:star + idx,staticClass:"far fa-star"})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }